import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './detail.css';
import Sidebar from '../../components/SideBar/Sidebar.js';
//import todayIcon from '../../assets/tour-sm.svg';
import { getTodayEvents } from '../../store/events/actions';
import { GetTimeZone } from '../../components/common/DateTimeFormatter';
//import { useParams } from 'react-router-dom';
import { hideLoading, showLoading } from '../../store/loading-reducer';
import PropTypes from 'prop-types';
import { shopMonitorSliderTime } from '../../helpers/enums';
import { getBadges } from '../../helpers/badges';
import ProfileImage from '../../assets/profile-lg.png';
import { calculateDateDiff } from '../../helpers/formatterHelper';
import { format } from 'date-fns';
import { getEmployeeWorkAnniversaries, getEmployeeList } from '../../store/employee/actions';

export default function ShopCelebrate({ handleloadinTiming }) {
    const dispatch = useDispatch();
    //const { todayEventNotifications } = useSelector(state => state.event);
    //const { fetchNext } = useParams();
    const [filter] = useState({ companyId: 0, timezone: GetTimeZone() });
    const isLoading = useSelector((state) => state.loading);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const { employeeAnniversaries, employeeList } = useSelector(state => state.employee);
    const navigate = useNavigate();
    const [isAnniversaries, setIsAnniversaries] = useState(false);
    const [isEmployeeList, setIsEmployeeList] = useState(false);
    const empFilter = { query: '', companyId: 0, skillId: 0, sort: 12 };


    useEffect(() => {
        document.title = 'Celebrate | CWP Team Connect';
        dispatch(showLoading());
        handleloadinTiming(shopMonitorSliderTime.LeadingTime);
        let sharpCompanyId = localStorage.getItem('monitor_mode_company');
        filter.companyId = (sharpCompanyId != null && sharpCompanyId !== undefined) ? parseInt(sharpCompanyId) : 0;
        dispatch(getTodayEvents(filter)).unwrap().then(() => {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
            setIsDataLoaded(true);
        });
    }, []);

    useEffect(() => {
        dispatch(getEmployeeWorkAnniversaries(filter)).unwrap().then(() => {
            setIsAnniversaries(true);
        });
        dispatch(getEmployeeList(empFilter)).unwrap().then(() => {
            setIsEmployeeList(true);
        });
    }, [filter]);


    useEffect(() => {
        if (isLoading && isDataLoaded) {
            dispatch(hideLoading());
            handleloadinTiming(shopMonitorSliderTime.default);
        }
    }, [isLoading, isDataLoaded]);

    let checkPrimaryCompanyName = '';
    const hidePrimaryCompanyName = (companyName) => {
        if (checkPrimaryCompanyName != companyName) {
            checkPrimaryCompanyName = companyName;
            return true;
        }
        return false;
    }
    let checkPrimaryCompanyNameAnn = '';
    const hidePrimaryCompanyNameAnn = (companyName) => {
        if (checkPrimaryCompanyNameAnn != companyName) {
            checkPrimaryCompanyNameAnn = companyName;
            return true;
        }
        return false;
    }
    useEffect(() => {
        if (isAnniversaries === true && isEmployeeList === true) {
            dispatch(hideLoading());
        }
    }, [isAnniversaries, isEmployeeList]);

    return (
        <div className="monitors-inner">
            <div className="monitors-item">
                <div className="monitors-header-wrap">
                    {/*<p className="monitors-header-title">Today</p>*/}
                    {/*<span className="monitors-header-icon"><img src={todayIcon} alt="Today Icon" /></span>*/}
                </div>
                <div className="monitors-item-event-wrap">

                    <div className="dashboard-anniversary-outer-wrapper">
                        {/* Anniversaries Section - Hide if no anniversaries */}
                        {employeeAnniversaries && employeeAnniversaries.length > 0 && (
                            <div className="dashboard-anniversary-section-wrap">
                                <p className="monitors-header-title">Anniversaries</p>
                                <div className="dashboard-anniversary-wrap">
                                    <div className="dashboard-anniversary-inner">
                                        <div className="dashboard-content-item-inner"> 
                                            <div className="dashboard-flex-wrap">
                                                {[...(employeeAnniversaries || [])]
                                                    .sort((a, b) => (a?.primaryCompanyId || 0) - (b?.primaryCompanyId || 0))
                                                    .map(anniversarie => (
                                                        <>
                                                            {hidePrimaryCompanyNameAnn(anniversarie?.primaryCompanyName) && (
                                                                <span className="dashbord-anniversary-profile-place-title">{anniversarie?.primaryCompanyName}</span>
                                                            )}
                                                            <a onClick={() => navigate('/profile/' + anniversarie.id)} className="dashboard-anniversary-block-wrap" key={anniversarie.id}>
                                                                <span className="dashboard-anniversary-profile-wrap">
                                                                    <img src={anniversarie.profileImage ? anniversarie.profileImage.previewsrc : ProfileImage} alt="profile" loading="lazy" />
                                                                </span>
                                                                <div className="badgesIcon badgesIconAnn">
                                                                    {getBadges(calculateDateDiff(anniversarie?.startDate).yearsDiff)}
                                                                </div>
                                                                <span className="dashboard-anniversary-inner-wrap">
                                                                    <span className="dashboard-anniversary-text-wrap">
                                                                        {(anniversarie?.nickname || anniversarie?.firstName) + ' ' + anniversarie?.lastName}
                                                                    </span>
                                                                    <span className="dashboard-anniversary-years-wrap">
                                                                        <span>{calculateDateDiff(anniversarie.startDate).yearsDiff} {calculateDateDiff(anniversarie?.startDate).yearsDiff > 1 ? 'years' : 'year'}</span>
                                                                    </span>
                                                                </span>
                                                            </a>
                                                        </>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Birthdays Section - Hide if no birthdays */}
                        {employeeList &&
                            employeeList.length > 0 &&
                            employeeList.some(employee => employee.birthDate && !employee.hideBirthDate) && (
                                <div className="dashboard-birthday-section-wrap">
                                    <p className="monitors-header-title">Birthdays</p>
                                    <div className="dashboard-birthday-wrap">
                                        <div className="dashboard-birthday-inner">
                                            <div className="dashboard-content-item-inner">
                                                {[...employeeList]
                                                    .filter(employee => employee.birthDate && !employee.hideBirthDate)
                                                    .map(employee => ({
                                                        ...employee,
                                                        birthMonth: new Date(employee.birthDate).getMonth(),
                                                        birthDay: new Date(employee.birthDate).getDate(),
                                                    }))
                                                    .filter(({ birthMonth, birthDay }) => {
                                                        const today = new Date();
                                                        const currentMonth = today.getMonth();
                                                        const currentDay = today.getDate();
                                                        return birthMonth > currentMonth || (birthMonth === currentMonth && birthDay >= currentDay);
                                                    })
                                                    .sort((a, b) => {
                                                        const dateA = new Date(new Date().getFullYear(), a.birthMonth, a.birthDay);
                                                        const dateB = new Date(new Date().getFullYear(), b.birthMonth, b.birthDay);
                                                        return dateA - dateB;
                                                    })

                                                    .slice(0, 3)
                                                    .map((employee, index) => {
                                                        const birthDate = new Date(employee.birthDate);
                                                        birthDate.setFullYear(new Date().getFullYear());
                                                        const formattedDate = format(birthDate, "EEEE, MMMM d");
                                                        return (

                                                            <React.Fragment key={employee.id || index}>
                                                                {hidePrimaryCompanyName(employee?.primaryCompanyName) && (
                                                                    <p className="dashboard-anniversary-profile-title">{employee?.primaryCompanyName}</p>
                                                                )}
                                                                <div className="dashboard-flex-wrap">
                                                                    <a className="dashboard-anniversary-block-wrap" onClick={() => navigate('/profile/' + employee?.id)}>
                                                                        <span className="dashboard-anniversary-profile-wrap">
                                                                            <img src={employee?.profileImage?.previewsrc ? employee.profileImage.previewsrc : ProfileImage} alt="employee birthdays placeholder" />
                                                                        </span>
                                                                        <span className="dashboard-anniversary-inner-wrap">
                                                                            <span className="dashboard-anniversary-text-wrap">
                                                                                {employee?.fullName}
                                                                            </span>
                                                                            <span className="dashboard-anniversary-years-wrap">
                                                                                <span>{formattedDate}</span>
                                                                            </span>
                                                                        </span>
                                                                    </a>
                                                                </div>
                                                            </React.Fragment>

                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>

                    {/*{todayEventNotifications && todayEventNotifications.length === 0 && (*/}
                    {/*	<div className="monitors-item-event-item">*/}
                    {/*		<div className="monitors-item-event-full">*/}
                    {/*			<span className="news-description">No Tours or Visitors Today</span>*/}
                    {/*		</div>*/}
                    {/*	</div>*/}
                    {/*)}*/}


                    {/*{todayEventNotifications && todayEventNotifications.length > 0 && todayEventNotifications.slice(fetchNext * 5, (fetchNext + 1) * 5).map(eventLogDate => {*/}
                    {/*	// Declare the variable outside of JSX block*/}
                    {/*	let firstLogDate = null;*/}
                    {/*	if (eventLogDate.eventLog && eventLogDate.eventLog.length > 0) {*/}
                    {/*		firstLogDate = eventLogDate.eventLog[0];*/}
                    {/*	}*/}
                    {/*	return (*/}
                    {/*		firstLogDate && (*/}
                    {/*			<div className={`monitors-item-event-item ${firstLogDate.isEventAllDay ? 'all-day-event' : ''}`} key={firstLogDate.id}>*/}
                    {/*				<div className="monitors-item-event-full">*/}
                    {/*					<div className="monitors-item-event-title-wrap">*/}
                    {/*						<p className="monitors-event-title">{eventLogDate.title}</p>*/}
                    {/*					</div>*/}
                    {/*					<p className="monitors-type-desc">{eventLogDate.eventType?.name} <span className="time-list">{'@ ' + firstLogDate.startTime}</span></p>*/}
                    {/*					*/}{/*<span className="news-day-title normal-title">{notification.eventType?.name === 'Visitor' ? notification.eventType?.name : `${notification.eventType?.name} ${notification.eventLog.length > 0 && notifaicationdate.startTime ? '@ ' + notifaicationdate.startTime : ''}`}</span>*/}
                    {/*				</div>*/}
                    {/*			</div>*/}
                    {/*		)*/}
                    {/*	);*/}
                    {/*})}*/}


                </div>
            </div>
            <Sidebar pageType={"celebrate"} />
        </div>
    );
}

ShopCelebrate.propTypes = {
    handleloadinTiming: PropTypes.func
};